/** @format */

import { useContext } from 'react';

import { EventContext } from '../../Contexts/EventContext';

export const useRole = () => {
  const eventContext = useContext(EventContext);
  const roles = (eventContext.authRoles ?? [])
    .map((r) => (typeof r === 'string' ? r : r?.name))
    .filter(Boolean);

  const can = (role) => roles.includes(role);

  const canBoard = () => roles.some((name) => name?.startsWith('Board'));

  return {
    can: (role) => can(role),
    canBoard: () => canBoard(),
  };
};
